export const WIDGET_METADATA_TYPE = 'metadata';
